import { InputObject } from "../controls/default";

/**
 * Map a **string** enum to combobox `{ value, display }` options.
 * (For numeric enums use a bespoke mapping — `Object.entries` on a numeric enum yields the reverse
 * key/value pairs too.)
 */
export function enumOptions(e: Record<string, string>): InputObject[] {
  return Object.entries(e).map(([value, display]) => ({ display, value }));
}

/** A combobox `request` that resolves a string enum's options — `request: enumRequest(ContentType)`. */
export const enumRequest =
  (e: Record<string, string>) => (): Promise<InputObject[]> =>
    Promise.resolve(enumOptions(e));
